import React from "react";
import { getIconSvg, IconName } from "./src/helper";
import { StyleSize } from "../../common/models";

interface Props {
  name: IconName;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  size?: StyleSize;
}

const Icon: React.FC<Props> = React.memo((props): React.ReactElement => {
  return (
    <div
      onClick={props.onClick}
      className={`Icon ${props.onClick ? "cursor-pointer" : ""} ${props.className ?? ""}`}
    >
      <React.Fragment key={props.name}>
        {getIconSvg(props.name, props.size)}
      </React.Fragment>
    </div>
  );
});

export default Icon;
